import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 14\" id=\"icon-order\">  <image id=\"icon-order_image0\" width=\"12\" height=\"14\" x=\"0\" y=\"0\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAQAAACxtDVnAAAABGdBTUEAALGPC/xhBQAAACBjSFJN\r\nAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN\r\nRQfiBxQLCRg0+MAPAAAAoElEQVQY063LoQrCUBiG4fc/O8ErGN6GYhKcTKPdavZOTBq9A6tRBEF2\r\nmqDYLKZFYQuaxB05hp2yoc03fg8fAGAWZgNglsmkXDTsdbBlwAWArspKUGYU3MldmyuA3NzDg8xk\r\nHo21o0klbVuxBRtKUQUVWwB5U0vxo3+AfAUXUIAZJuf64+lSM2Una+2HBiEAL1mRSqd38qBydwQg\r\n4xD1AT73UC1B1VYnDAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNy0yMFQxMTowOToyNCswODow\r\nMJJqevsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDctMjBUMTE6MDk6MjQrMDg6MDDjN8JHAAAA\r\nAElFTkSuQmCC\"></image>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order.svg
// module id = gYtG
// module chunks = 33